import React, { useEffect, useState } from 'react'
import { Badge, Dropdown, List, Spin, Typography, Divider } from 'antd'
import { BellOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import apiRequest from '../../hooks/ApiRequest'
import { useHistory } from 'react-router-dom';

const { Text } = Typography

const Notifications = () => {
  const [unread, setUnread] = useState([])
  const [read, setRead] = useState([])
  const [unreadCount, setUnreadCount] = useState(0)
  const [loading, setLoading] = useState(true)
  const history = useHistory();

  const fetchNotifications = async () => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_EMAIL}/Notification/GetNotificationSummary/summary`,
        'GET',
      )

      if (response?.data) {
        const unread = response.data.unreadNotifications || []
        const read = response.data.readNotifications || []
        setUnread(unread)
        setRead(read)
        setUnreadCount(response.data.unreadCount || 0)
      }
    } catch (err) {
      console.error('Failed to fetch notifications', err)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  const ReadNotification = async id => {
    const url = `${process.env.REACT_APP_BASE_URL_EMAIL}/Notification/UpdateNotification/${id}`
    const method = 'POST'
    try {
      const res = await apiRequest(url, method)
      if (res.success) {
        const item = unread.find(c => c.id === id)

        if (item.entityType === 'Policy') {
          localStorage.setItem('productId', item.productId);
          history.push(`/policies/${item.entityNumber}`);
        } else if (item.entityType === 'Quotation') {
          localStorage.setItem('productId', item.productId)
          history.push(`/quotations/${item.entityNumber}`);
        } else {
          window.open('https://outrisk-claim.kindlebit.com/', '_blank');
        }
      } else {
        // toast.error(res.message || 'Failed to update sum insured')
      }
    } catch (error) {
      //   toast.error('Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const ReopenNotifications = async id => {
    try {
      // debugger
      const item = read.find((c) => c.id === id);

      if (!item) {
        console.warn('Notification not found in read array');
        return;
      }

      if (item.entityType === 'Policy') {
        localStorage.setItem('productId', item.productId);
        history.push(`/policies/${item.entityNumber}`);
      } else if (item.entityType === 'Quotation') {
        localStorage.setItem('productId', item.productId);
        history.push(`/quotations/${item.entityNumber}`);
      } else {
        window.open('https://outrisk-claim.kindlebit.com/', '_blank');
      }
    } catch (error) {
      //   toast.error('Something went wrong. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const renderNotificationList = () => (
    <div
      style={{
        width: 360,
        maxHeight: 450,
        overflowY: 'auto',
        background: '#fff',
        borderRadius: 8,
        boxShadow: '0 2px 12px rgba(0,0,0,0.15)',
      }}>
      <div
        style={{
          padding: '12px 16px',
          borderBottom: '1px solid #f0f0f0',
          fontWeight: 600,
        }}>
        Notifications
      </div>

      {loading ? (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Spin size="small" />
        </div>
      ) : unread.length === 0 && read.length === 0 ? (
        <div style={{ padding: 20, textAlign: 'center' }}>
          <Text type="secondary">No notifications</Text>
        </div>
      ) : (
        <>
          {unread.length > 0 && (
            <>
              <div style={{ padding: '8px 16px', fontWeight: 600 }}>Unread</div>
              <List
                itemLayout="horizontal"
                dataSource={unread}
                renderItem={item => (
                  <List.Item
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#f0faff',
                      borderBottom: '1px solid #f0f0f0',
                    }}>
                    <List.Item.Meta
                      title={
                        <Link
                          to={item.activityUrl}
                          style={{ fontWeight: 600, color: '#1890ff' }}>
                          <span onClick={() => ReadNotification(item?.id)}> {item.message}</span>
                        </Link>
                      }
                      description={
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {new Date(item.displayTime).toLocaleString()}
                        </Text>
                      }
                    />
                  </List.Item>
                )}
              />
            </>
          )}

          {read.length > 0 && (
            <>
              <Divider style={{ margin: '8px 0' }} />
              <div style={{ padding: '8px 16px', fontWeight: 600 }}>Read</div>
              <List
                itemLayout="horizontal"
                dataSource={read}
                renderItem={item => (
                  <List.Item
                    style={{
                      padding: '10px 16px',
                      backgroundColor: '#fff',
                      borderBottom: '1px solid #f0f0f0',
                    }}>
                    <List.Item.Meta
                      title={
                        <Link
                          // to={item.activityUrl}
                          style={{ fontWeight: 400, color: '#8c8c8c' }}>
                          <span onClick={() => ReopenNotifications(item?.id)}> {item.message}</span>
                        </Link>
                      }
                      description={
                        <Text type="secondary" style={{ fontSize: 12 }}>
                          {new Date(item.displayTime).toLocaleString()}
                        </Text>
                      }
                    />
                  </List.Item>
                )}
              />
            </>
          )}
        </>
      )}
    </div>
  )

  return (
    <Dropdown
      overlay={renderNotificationList()}
      trigger={['click']}
      placement="bottomRight"
      arrow>
      <Badge count={unreadCount} offset={[-2, 2]}>
        <BellOutlined
          style={{ fontSize: 22, cursor: 'pointer', color: '#595959' }}
        />
      </Badge>
    </Dropdown>
  )
}

export default Notifications
